
// =====================================================
// AIMAPHOME.JSX
// Estate Experts — AI Map Generator Home Screen
// Exact image design with starry background
// All buttons & links active | aimap- prefix
// =====================================================

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaBuilding, FaArrowRight, FaRobot, FaCheck } from 'react-icons/fa';
import '../../../../assets/css/Buyer/Home/aidesign.css';

// ─────────────────────────────────────────
//  COMPONENT
// ─────────────────────────────────────────

export default function AIDesignGen() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Interior');

  // ── Navigate to main generator ──
  const handleStartNow = () => {
    navigate('/buyer/login');
  };

  // ── Navigate to design card ──
  const handleDesignClick = (type) => {
    navigate('/buyer/ai-generator', { state: { initialTab: type } });
  };

  // ─────────────────────────────────────────
  //  RENDER
  // ─────────────────────────────────────────
  return (
    <div className="aimap-home">
      <div className="aimap-container">

      

        

        {/* ── MAIN BODY (2 columns) ── */}
        <div className="aimap-body">

          {/* LEFT COLUMN: Steps + Button */}
          <div className="aimap-left">
              {/* ── HEADER ── */}
        <div className="aimap-header">
          <h1 className="aimap-title"> Get Suggestions Instantly from AI
          </h1>
          <p className="aimap-subtitle">
            {/* Get Suggestions Instantly from AI */}
          </p>
          <p className="aimap-description">
            Generate interior or exterior house designs tailored to your preferences. 
            Follow these simple steps to start.
          </p>
        </div>


        {/* ── TABS (Interior / Exterior) ── */}
        <div className="aimap-tabs">
          {/* <span
            className={`aimap-tab ${activeTab === 'Interior' ? 'active' : ''}`}
            onClick={() => setActiveTab('Interior')}
          >
            Interior
          </span>
          <span
            className={`aimap-tab ${activeTab === 'Exterior' ? 'active' : ''}`}
            onClick={() => setActiveTab('Exterior')}
          >
            Exterior
          </span> */}
          
  <p className="aimap-tab">Interior</p>
  <p className="aimap-tab">Exterior</p>

        </div>




            <h2 className="aimap-steps-title">Few Simple Steps</h2>

            <div className="aimap-steps">
              <div className="aimap-step">
                <div className="aimap-step-num">1</div>
                <div className="aimap-step-text">
                  Choose Exterior or Interior
                </div>
              </div>

              <div className="aimap-step">
                <div className="aimap-step-num">2</div>
                <div className="aimap-step-text">
                  Set Your Budget
                </div>
              </div>

              <div className="aimap-step">
                <div className="aimap-step-num">3</div>
                <div className="aimap-step-text">
                  Select Design Preferences
                </div>
              </div>
            </div>

            <button className="aimap-start-btn" onClick={handleStartNow}>
              Start Now
              <FaArrowRight className="aimap-btn-arrow" />
            </button>
          </div>

          {/* RIGHT COLUMN: Design Cards */}
          <div className="aimap-right">
            {/* Interior Design Card */}
            <div
              className="aimap-design-card"
              onClick={() => handleDesignClick('Interior')}
            >
              <img
                src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&h=500&fit=crop"
                alt="Interior Design"
                className="aimap-card-img"
              />
              <div className="aimap-card-overlay">
                <div className="aimap-card-label">
                  <FaHome className="aimap-card-icon" />
                  Interior Design
                </div>
              </div>
            </div>

            {/* Exterior Design Card */}
            <div
              className="aimap-design-card"
              onClick={() => handleDesignClick('Exterior')}
            >
              <img
                src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=500&fit=crop"
                alt="Exterior Design"
                className="aimap-card-img"
              />
              <div className="aimap-card-overlay">
                <div className="aimap-card-label">
                  <FaBuilding className="aimap-card-icon" />
                  Exterior Design
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* ── SIDEBAR INFO BOX (Right side) ── */}
        {/* <div className="aimap-sidebar">
          <h3 className="aimap-sidebar-title">
            <FaRobot className="aimap-sidebar-icon" />
            Get suggestions from AI
          </h3>

          <p className="aimap-sidebar-text">
            Generate custom designs based on your preferences
          </p>

          <div className="aimap-checklist">
            <div className="aimap-checklist-item">
              <FaCheck className="aimap-checklist-icon" />
              Exterior / Interior
            </div>
            <div className="aimap-checklist-item">
              <FaCheck className="aimap-checklist-icon" />
              Budget
            </div>
            <div className="aimap-checklist-item">
              <FaCheck className="aimap-checklist-icon" />
              Design Preference
            </div>
          </div>

          <button className="aimap-sidebar-btn" onClick={handleStartNow}>
            Start Now
            <FaArrowRight />
          </button>
        </div> */}

      </div>
    </div>
  );
}